export default __webpack_public_path__ + "static/O0058-2b33a1cc12a952970c655c80c4ad65d4.png";